"use client"
import React, {useEffect, useRef, useState} from "react"
import TempMessage from "../../../../../components/TempMessage/TempMessage";
import { BsStar, BsThreeDotsVertical, BsStarFill } from "react-icons/bs";
import { ImShare } from "react-icons/im";
import { VscMultipleWindows } from "react-icons/vsc";
import { FaRegEdit } from "react-icons/fa";
import {useTekstClient} from "../../../../../hooks/useTekstClient";
import useGebruiker from "../../../../../hooks/useGebruiker";
import {useShareUrl} from "../../Hooks/useShareUrl";
import {Dropdown} from "components/ui"
import {useFormTitle} from "../../../../../hooks/useFormTitle";
const ContentListItemRight = ({item, handleBookmark, handleOpenInNieuwVenter, handleBewerken}) => {
    const {tekst} = useTekstClient()
    const {ingelogdeGebruiker} = useGebruiker()
    const [showKopieMsg,  handleDelen] = useShareUrl(false)
    const [showDropdown, setShowDropdown] = useState(false)
    const dropdownRef = useRef(null)
    const {formTitle} = useFormTitle()

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false)
            }
        }

        document.addEventListener("mousedown", handleClickOutside)
        return () => document.removeEventListener("mousedown", handleClickOutside)
    }, [])

    return (
        <div className={`flex items-center gap-2`}>
            {/*Bookmark*/}
            {ingelogdeGebruiker && (item.bookmarked ?
                <BsStarFill className={`text-kleur-geel cursor-pointer`}
                            onClick={() => handleBookmark(item.id)}
                            title={tekst('pagina:support:kenniscentrum:lijst-item:favoriet:titel')}
                ></BsStarFill>
                :
                <BsStar
                    className={`` + (ingelogdeGebruiker ? 'cursor-pointer' : ' ' + ``)}
                    onClick={() => ingelogdeGebruiker && handleBookmark(item.id)}
                    title={!ingelogdeGebruiker && tekst('pagina:support:kenniscentrum:lijst-item:favoriet:inlogvereist')}
                />)
            }

            {/*DropdownOptions*/}
            <Dropdown className={`relative`} ref={dropdownRef}>
                <TempMessage
                    variant={'info'}
                    message={'De link is gekopieerd'}
                    show={showKopieMsg}
                />
                <Dropdown.Toggle
                    id="dropdown-custom-components"
                    onClick={() => setShowDropdown((prev) => !prev)}
                >
                    <BsThreeDotsVertical/>
                </Dropdown.Toggle>
                <Dropdown.Menu show={showDropdown} className={``}>
                    <Dropdown.Item className={`flex items-center gap-1`} eventKey="1" onClick={() => {
                        handleDelen(`${window.location.href.split('?')[0]}/id/${item.id}/${formTitle(item.content_gepubliceerd?.titel)}`)
                        setShowDropdown(false)
                    }}><ImShare/>{tekst('pagina:support:kenniscentrum:lijst-item:menu:delen')}
                    </Dropdown.Item>
                    <Dropdown.Item className={`flex items-center gap-1`} eventKey="2"
                                   onClick={() => {
                                       handleOpenInNieuwVenter(item)
                                       setShowDropdown(false)
                                   }}><VscMultipleWindows/>{tekst('pagina:support:kenniscentrum:lijst-item:menu:Open in nieuw venter')}
                    </Dropdown.Item>
                    {ingelogdeGebruiker && item.ingelogdeGebruikerMagSchrijven === 1
                        && <Dropdown.Item className={`flex items-center gap-1`} eventKey="3"
                                          onClick={() => {
                                              handleBewerken(item)
                                              setShowDropdown(false)
                                          }}><FaRegEdit/>{tekst('algemeen:Bewerken')}
                        </Dropdown.Item>
                    }
                </Dropdown.Menu>
            </Dropdown>
        </div>
    )
}

export default ContentListItemRight
